/*
 * ProduktPilot24: Partner-Tag je Kanal (Amazon-PartnerNet Tracking-IDs).
 * Kommt der Besuch ueber einen bekannten Kanal (utm_source / utm_medium=bio / Google-Referrer),
 * bekommt jeder Amazon-Link auf der Seite das passende tag=. Die Metafelder der Produkte bleiben unveraendert
 * (Standard produktpilo02-21), umgeschrieben wird nur im Browser beim Rendern und beim Klick.
 * Datenschutz: Es wird NICHTS im Browser gespeichert (kein Cookie, kein localStorage, kein sessionStorage).
 * Der Kanal steckt nur in der URL und wird auf interne Links weitergereicht. Keine Pixel, keine Daten an Dritte.
 */
(function () {
  'use strict';

  var DEFAULT_TAG = 'produktpilo02-21';
  var TAGS = {
    bio: 'pp24bio-21',
    instagram: 'pp24insta-21',
    tiktok: 'pp24tiktok-21',
    pinterest: 'pp24pin-21',
    youtube: 'pp24yt-21',
    google: 'pp24google-21'
  };
  var ALIAS = {
    instagram: 'instagram', ig: 'instagram', insta: 'instagram',
    tiktok: 'tiktok', tt: 'tiktok',
    pinterest: 'pinterest', pin: 'pinterest',
    youtube: 'youtube', yt: 'youtube',
    google: 'google'
  };
  var KEEP = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var SKIP_PATHS = /^\/(cart|checkout|checkouts|account|admin|apps|services|wpm|cdn|\.well-known)(\/|$)/;
  var AMAZON_HOST = /(^|\.)amazon\.(de|com|co\.uk|fr|it|es|nl|pl|se|com\.be|ie)$/i;

  function detect() {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return null; }
    var source = (q.get('utm_source') || '').toLowerCase();
    var medium = (q.get('utm_medium') || '').toLowerCase();
    var channel = null;
    var carry = {};
    var i;

    for (i = 0; i < KEEP.length; i++) {
      var v = q.get(KEEP[i]);
      if (v) carry[KEEP[i]] = v;
    }

    if (medium === 'bio') {
      channel = 'bio';
    } else if (source) {
      channel = ALIAS[source] || null;
    } else {
      try {
        if (document.referrer) {
          var rh = new URL(document.referrer).hostname;
          if (/(^|\.)google\.[a-z.]+$/i.test(rh) && rh !== window.location.hostname) {
            channel = 'google';
            carry = { utm_source: 'google' };
          }
        }
      } catch (e) { /* kein Referrer */ }
    }

    if (!channel) return null;
    return { channel: channel, tag: TAGS[channel], carry: carry };
  }

  var info = detect();
  if (!info) return;
  document.documentElement.setAttribute('data-pp-channel', info.channel);

  function processLink(a) {
    if (!a || !a.getAttribute) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
    var u;
    try { u = new URL(href, window.location.href); } catch (e) { return; }
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return;

    if (AMAZON_HOST.test(u.hostname)) {
      var cur = u.searchParams.get('tag');
      if (cur && (cur === DEFAULT_TAG || /^pp24[a-z]+-21$/.test(cur)) && cur !== info.tag) {
        u.searchParams.set('tag', info.tag);
        a.setAttribute('href', u.toString());
      }
      return;
    }

    if (u.host !== window.location.host) return;
    if (SKIP_PATHS.test(u.pathname)) return;
    if (u.pathname === window.location.pathname && u.search === window.location.search && u.hash) return;
    if (u.searchParams.get('utm_source')) return;

    var changed = false;
    for (var k in info.carry) {
      if (Object.prototype.hasOwnProperty.call(info.carry, k) && !u.searchParams.has(k)) {
        u.searchParams.set(k, info.carry[k]);
        changed = true;
      }
    }
    if (changed) a.setAttribute('href', u.pathname + u.search + u.hash);
  }

  function processAll(root) {
    var links = (root || document).querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) processLink(links[i]);
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = window.setTimeout(function () { timer = null; processAll(document); }, 150);
  }

  function onInteract(e) {
    var t = e.target;
    if (t && t.closest) processLink(t.closest('a[href]'));
  }

  processAll(document);
  document.addEventListener('DOMContentLoaded', function () { processAll(document); });
  window.addEventListener('load', function () { processAll(document); });
  ['mousedown', 'click', 'auxclick', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, onInteract, true);
  });
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/*
 * ProduktPilot24: Hinweis und Amazon-Knopf im TikTok-In-App-Browser (Theme v20).
 * Der TikTok-eigene Browser oeffnet Amazon nicht (target=_blank wird mit "Oeffne diesen Link in deinem Browser" abgefangen).
 * Nur wenn der User-Agent TikTok verraet: schlichter Hinweis-Balken ganz oben und target an Amazon-Links entfernen.
 * Alle anderen Browser (auch Instagram) bleiben unveraendert. Es wird nichts gespeichert, es gibt keine Pixel.
 */
(function () {
  'use strict';
  var ua = '';
  try { ua = navigator.userAgent || ''; } catch (e) { return; }
  if (!/musical_ly|bytedancewebview|bytelocale|tiktok|trill/i.test(ua)) return;

  var TEXT = {
    de: 'Für Amazon bitte im Browser öffnen: oben rechts „⋯“ antippen, dann „Im Browser öffnen“.',
    en: 'To open Amazon, please use your browser: tap “⋯” at the top right, then “Open in browser”.',
    es: 'Para abrir Amazon, usa tu navegador: toca «⋯» arriba a la derecha y luego «Abrir en el navegador».',
    fr: 'Pour ouvrir Amazon, utilisez votre navigateur : appuyez sur « ⋯ » en haut à droite, puis sur « Ouvrir dans le navigateur ».',
    hr: 'Za otvaranje Amazona koristite preglednik: dodirnite „⋯“ gore desno, zatim „Otvori u pregledniku“.',
    pl: 'Aby otworzyć Amazon, użyj przeglądarki: dotknij „⋯“ w prawym górnym rogu, potem „Otwórz w przeglądarce“.',
    ru: 'Чтобы открыть Amazon, используйте браузер: нажмите «⋯» вверху справа, затем «Открыть в браузере».',
    sq: 'Për të hapur Amazon, përdorni shfletuesin: prekni „⋯“ lart djathtas, pastaj „Hap në shfletues“.',
    tr: 'Amazon’u açmak için tarayıcıyı kullanın: sağ üstteki “⋯” simgesine dokunun, ardından “Tarayıcıda aç”.',
    ar: 'لفتح Amazon يرجى استخدام المتصفح: اضغط على «⋯» في الأعلى ثم «فتح في المتصفح».'
  };
  var AMAZON_HOST = /(^|\.)amazon\.(de|com|co\.uk|fr|it|es|nl|pl|se|com\.be|ie)$/i;

  document.documentElement.setAttribute('data-pp-inapp', 'tiktok');

  function addBar() {
    if (document.getElementById('pp-inapp-bar') || !document.body) return;
    var l = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    var bar = document.createElement('div');
    bar.id = 'pp-inapp-bar';
    bar.setAttribute('role', 'note');
    bar.setAttribute('dir', document.documentElement.getAttribute('dir') || 'ltr');
    bar.textContent = TEXT[l] || TEXT.en;
    bar.style.cssText = 'background:#fff3cd;color:#3d2f00;border-bottom:1px solid #e6c866;padding:10px 16px;' +
      'font:600 14px/1.4 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;text-align:center;';
    document.body.insertBefore(bar, document.body.firstChild);
  }

  function fixLink(a) {
    if (!a || !a.getAttribute || !a.hasAttribute('target')) return;
    var href = a.getAttribute('href');
    if (!href) return;
    var u;
    try { u = new URL(href, window.location.href); } catch (e) { return; }
    if (AMAZON_HOST.test(u.hostname)) a.removeAttribute('target');
  }

  function fixAll() {
    var links = document.querySelectorAll('a[target][href]');
    for (var i = 0; i < links.length; i++) fixLink(links[i]);
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = window.setTimeout(function () { timer = null; fixAll(); }, 150);
  }

  function start() {
    addBar();
    fixAll();
    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    }
    ['mousedown', 'click', 'auxclick', 'touchstart', 'keydown'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var t = e.target;
        if (t && t.closest) fixLink(t.closest('a[href]'));
      }, true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();